"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncUrlHistoryAndFilters = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const SearchResultTabService_1 = require("../../services/SearchResultTabService");
const constants_1 = require("../../constants");
const useSyncUrlHistoryAndFilters = (tabs, currentSelectedTab, configData, setSelectedTab, setLastUserAction, setIsHitsAndFiltersLoading) => {
    const { setUiState } = (0, react_instantsearch_1.useInstantSearch)();
    const typeFilterUrlKey = configData.isDocumentPage ? constants_1.DOCUMENT_TYPE_KEY : constants_1.TAB_KEY;
    React.useEffect(() => {
        const getParamsFromUrlAndLoadData = () => {
            setIsHitsAndFiltersLoading(true);
            const tabFromUrl = app_1.UrlService.GetQueryValueFromUrl(typeFilterUrlKey) || '';
            let selectedTab = currentSelectedTab;
            if (tabFromUrl && tabFromUrl !== currentSelectedTab.key) {
                selectedTab = tabs.find(tab => tab.key === tabFromUrl) || tabs[0];
                setSelectedTab(selectedTab);
                setLastUserAction({
                    name: app_1.LastUserActionNameEnum.Tab,
                    key: selectedTab.key,
                });
            }
            const uiStateFromUrl = SearchResultTabService_1.searchResultTabService.getInitialUiState(selectedTab, configData.documentPreselectedLanguages, configData.culture);
            setUiState(uiStateFromUrl);
        };
        globalThis.addEventListener('popstate', getParamsFromUrlAndLoadData);
        return () => {
            globalThis.removeEventListener('popstate', getParamsFromUrlAndLoadData);
        };
    }, []);
};
exports.useSyncUrlHistoryAndFilters = useSyncUrlHistoryAndFilters;
